import { gql } from '@apollo/client';

export const GET_GLOBAL_ACTIVITY_APPLICATION_QUESTIONS = gql`
  query GetGlobalActivityApplicationQuestions {
    vm {
      globalActivityApplicationQuestions {
        activityApplicationQuestionId
        label
        type
        required
        order
      }
    }
  }
`;
